import React from 'react';
import { classNames } from '../helpers/functions';
import AssetHolder from './AssetHolder';

const MultiAssetHolder = ({ assets, i = 0 }) => {
	return assets?.length > 5 ? (
		<>
			{assets?.slice(0, 5).map((asset, i) => (
				<AssetHolder asset={asset} i={i} />
			))}{' '}
			<div class={`group relative flex z-${10 - i}`}>
				<span className="ml-1.5 text-gray-500">{`+ ${
					assets.length - 5
				} more`}</span>
				<span
					class={`absolute top-8 scale-0 transition-all rounded p-2 text-xs group-hover:scale-100 whitespace-nowrap border px-3 left-0 bg-white z-${
						10 - i
					}`}
				>
					{assets.slice(5, assets.length).map((asset, i) => (
						<div
							className={classNames(
								'py-2',
								i !== assets.length - 6 && 'border-b'
							)}
						>
							<div>{`${asset?.manufacturerName || asset?.manufacturer?.name} ${
								asset?.modelName || asset?.model?.name
							}`}</div>
							<div className="text-gray-500 text-xxs">{`S/N: ${asset?.serialNumber}`}</div>
							<div className="text-gray-500 text-xxs">{`Tag: ${asset?.tag}`}</div>
						</div>
					))}
				</span>
			</div>
		</>
	) : (
		assets?.map((asset, i) => {
			return <AssetHolder asset={asset} i={i} />;
		})
	);
};

export default MultiAssetHolder;
